import { useForm } from "react-hook-form"
import { FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { HelperText, Spacer } from "../../atoms/Atoms"
import { CompleteUsaStateSelect } from "components/views/atoms/forms/FormUsaStateSelect"
import { FleLinkWrapper } from "../../atoms/Links"
import React from "react"
import L10n from "../../../../lib/carrot-l10n"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Form } from "components/views/atoms/forms/Form"
import { CompleteFormTextArea } from "components/views/atoms/forms/FormTextArea"
import { TopSection } from "../TopSection"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYouAddress = ({ address1, address2, city, state, zip, nonUsaAddress, isUsa, onComplete }) => {
  const { register, handleSubmit, errors } = useForm()

  return (
    <FleLayout>
      <Form onSubmit={handleSubmit(onComplete)}>
        <TopSection progressStep={2} leftOrBackArrow={<BackArrow />} />
        <SwitchH2ToBodyLarge>{l`What's your home address?`}</SwitchH2ToBodyLarge>
        <Spacer height={0.25} />
        <HelperText color="black-80">
          {l`Your address helps us recommend the right care and providers near you.`}
        </HelperText>
        <Spacer height={3} />
        {isUsa ? (
          <>
            <CompleteFormInput
              name={"address1"}
              label={"Address Line 1"}
              defaultValue={address1}
              errors={errors}
              ref={register({
                required: "Address line 1 cannot be left blank"
              })}
            />
            <CompleteFormInput
              name={"address2"}
              label={"Address Line 2 (Optional)"}
              defaultValue={address2}
              errors={errors}
              ref={register}
            />
            <CompleteFormInput
              name={"city"}
              label={"City"}
              defaultValue={city}
              errors={errors}
              ref={register({ required: "City cannot be left blank" })}
            />
            <CompleteUsaStateSelect
              name={"state"}
              label={"State"}
              defaultValue={state}
              errors={errors}
              ref={register({ required: "State cannot be left blank" })}
            />
            <CompleteFormInput
              name={"zip"}
              label={"Zipcode"}
              defaultValue={zip}
              errors={errors}
              ref={register({
                required: "Zipcode cannot be left blank",
                pattern: {
                  value: /^\d{5}$/,
                  message: "Zipcode must be 5 digits long"
                }
              })}
            />
          </>
        ) : (
          <>
            <CompleteFormTextArea
              name={"nonUsaAddress"}
              label={"Home Address"}
              defaultValue={nonUsaAddress}
              placeholder={l`client.accountSettings.nonUsaAddressPlaceholder`}
              errors={errors}
              ref={register({ required: "Address field cannot be left blank" })}
            />
          </>
        )}
      </Form>
      <FleLinkWrapper>
        <ContinueArrow onClick={handleSubmit(onComplete)} />
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { AboutYouAddress }
